import { ChangeDetectionStrategy, Component } from '@angular/core';
import { IPageDataV3 } from '@df/catalog/cms/cms-model.interface';
import { NICmsContentField } from '@icms/core/content/interfaces/icms-content-field.interfaces';
import { ICmsPageType } from '@icms/core/content/page/icms-page-type.decorator';
import { LocalICmsPage } from '../../../../catalog/page/local/local-page';
import { PageViewAbstract } from '../../../../catalog/page/view/page-view.abstract';
import { CmsBlogContentPostListingViewComponent } from '../../content/post-listing/cms-blog-content-post-listing.component';

export const BLOG_TAB = 'Blog';

export namespace NBlogRootPageType {
    export const typeId = 'blog-root';

    export interface ITypeData {
        /**
         * Copy belop page title
         */
        topCopy: string;
        /**
         * If true then tag will redirect location
         * otherwise they will act as a filter without changes
         */
        tagRedirect: string;
    }
}

@ICmsPageType({
    id: NBlogRootPageType.typeId,
    title: 'Blog root',
    fields: [
        {
            type: NICmsContentField.EFieldType.text,
            key: 'typeData.topCopy',
            title: 'Top copy',
            canShow: d => !d.useParent,
            tab: BLOG_TAB
        },
        {
            type: NICmsContentField.EFieldType.toggle,
            key: 'typeData.tagRedirect',
            title: 'Redirect location on tag change',
            default: true,
            tab: BLOG_TAB
        }
    ]
})
@Component({
    selector: 'cms-blog-page-root-view',
    templateUrl: './cms-blog-page-root-view.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [CmsBlogContentPostListingViewComponent]
})
export class CmsBlogPageRootViewComponent extends PageViewAbstract {
    override model?: LocalICmsPage<IPageDataV3>
}
